// import toast from 'react-hot-toast';
import { Avatar } from '../../avatars';
import { Style, Garment, fetchStyleSizeRecommendation } from '../../garments';
import { SizeRecommendationCache } from '../garments/sizeRecommendationCache';
import { HomeDispatch } from '../store/homeStore';
import { filterStyleVariantSizes } from '../../garments/stylesService';
import { homeActions } from '../slices/homeSlice';

const sizeRecommendationCache = new SizeRecommendationCache();

/**
 * Recommend variant size.
 * @param dispatch Redux dispatch function.
 * @param avatarId the avatar ID.
 * @param style the garment ID.
 * @param variantName the variant name.
 * @param poseId the pose ID.
 */
export async function recommendVariantSize(
  dispatch: HomeDispatch,
  avatar: Avatar,
  style: Style,
  variant: string,
): Promise<Garment> {
  // Filter available sizes.
  const sizes = filterStyleVariantSizes(style, variant);

  // Single size case.
  if (sizes.length === 1) {
    return sizes[0];
  }

  // Retrieve from size recommendation cache
  const sizeCache = sizeRecommendationCache.getRecommendation(avatar.id, style.id, variant);
  if (sizeCache) {
    const garmentVariant = sizes.find(s => s.size === sizeCache);
    if (garmentVariant) {
      return garmentVariant;
    }
  }

  dispatch(homeActions.beginSizeRecommendation());

  // Request size recommendation.
  const sizeRes = await fetchStyleSizeRecommendation(
    style.id,
    avatar.sex,
    avatar.smplShape,
    variant,
  );
  const size = sizeRes.size;

  // Cache size recommendation.
  sizeRecommendationCache.setRecommendation(avatar.id, style.id, variant, size);

  dispatch(homeActions.endSizeRecommendation());

  // TODO: Toast size recommendation?
  // toast.success(`${style.brand} ${style.name} size ${size}`);

  const garment = style.variants.find(v => v.variant === variant && v.size === size) as Garment;

  return garment;
}
